import React from 'react';

import styles from './index.module.scss';

import { ChoiceForm, Translation } from '../../common';

import manDog from '../../../assets/img/feedback/man-dog.jpg';

class Feedback extends React.Component {
  componentDidMount() {
    const { getQuestions, language, questions } = this.props;
    if (!questions && language) {
      getQuestions();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { getQuestions, language } = this.props;
    if (language !== prevProps.language) {
      getQuestions();
    }
  }

  onSubmit = (values) => {
    const { questions, sendAnswers, value } = this.props;
    sendAnswers({
      answers: questions
        ? questions.map(({ group, id }) => ({
            group,
            id,
            value: +values[id] || 0,
          }))
        : null,
      value,
    });
  };

  render() {
    const {
      questions,
      avatarComponent: NamedAvatar,
      logo,
      showTopImage,
    } = this.props;
    return (
      <div className={styles['feedback__wrapper']}>
        {showTopImage ? (
          <div className={styles['feedback__head-wrapper']}>
            <div className={styles['feedback__head']}>
              <img
                className={styles['feedback__head-image-man-dog']}
                src={manDog}
                alt="man-dog"
              />
              <img
                className={styles['feedback__head-image-logo']}
                src={logo}
                alt="logo"
              />
              <div className={styles['feedback__head-content']}>
                <h1>
                  <Translation>
                    FEEDBACK_PAYMENT_PHOTO_TEXT
                  </Translation>
                </h1>
              </div>
            </div>
          </div>
        ) : null}
        <div className={styles['feedback__questions']}>
          <h1 className={styles['feedback__questions-header']}>
            <Translation>FEEDBACK_HEADER</Translation>
          </h1>
          <Translation className={styles['feedback__questions-content']}>
            FEEDBACK_BOX
          </Translation>
          <ChoiceForm
            {...{ styles, questions }}
            onSubmit={this.onSubmit}
            pageName="mollie-feedback"
            button="Verzenden"
          >
            <NamedAvatar className={styles['feedback__avatar']} />
          </ChoiceForm>
        </div>
      </div>
    );
  }
}

export default Feedback;
